import i18n from "i18next";
import { messages } from "./languages";
import { session } from "../services/storageService";

const savedLanguage = session.getLanguage();

i18n.init({
	debug: true,
	defaultNS: "translations",
	fallbackLng: "es",
	ns: "translations",
	resources: messages,
	lng: savedLanguage,
} as any);

export const changeLanguage = (language: string) => {
	i18n.changeLanguage(language);
	session.setLanguage(language);
};

// Re-export as `any` so i18n.t() returns `any` (assignable to ReactNode)
// Runtime behavior is unchanged — only TypeScript's view changes.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const i18nAny: any = i18n;
export { i18nAny as i18n };


